export const FIREBASE_DATA_SOURCE = 'firebase'
export const BACKEND_DATA_SOURCE = 'backend'
export const CANARY_DATA_SOURCE = 'canary'

export const selectDataSource = (firebaseUid, environment = process.env) => {
    const mode = String(
        environment.REACT_APP_DATA_SOURCE || BACKEND_DATA_SOURCE
    )
        .trim()
        .toLowerCase()

    if (mode === BACKEND_DATA_SOURCE) {
        return BACKEND_DATA_SOURCE
    }
    if (mode === FIREBASE_DATA_SOURCE) {
        return FIREBASE_DATA_SOURCE
    }
    if (mode !== CANARY_DATA_SOURCE) {
        throw new Error(`Unsupported MineCards data source: ${mode}`)
    }
    if (!firebaseUid) {
        return FIREBASE_DATA_SOURCE
    }

    const canaryUids = String(environment.REACT_APP_BACKEND_CANARY_UIDS || '')
        .split(',')
        .map((uid) => uid.trim())
        .filter(Boolean)

    return canaryUids.includes(firebaseUid)
        ? BACKEND_DATA_SOURCE
        : FIREBASE_DATA_SOURCE
}

export const assertLegacyFirebaseDataSource = (environment = process.env) => {
    if (selectDataSource(undefined, environment) === BACKEND_DATA_SOURCE) {
        throw new Error(
            'Legacy Firebase data access is disabled in backend mode'
        )
    }
}
